import { Button as MuiButton } from '@mui/material'
import ButtonGroup from '@mui/material/ButtonGroup'
import { useOrderStore } from 'modules/orders/store'
import { useTableContext } from 'components'
import { useDisclosure } from 'utils'
import { SelectUnityModal } from './SelectUnityModal'

export const FilterListOrderMode = () => {
  const { setPagination } = useTableContext()
  const setFilters = useOrderStore.useSetFilters()
  const setSort = useOrderStore.useSetSort()
  const filters = useOrderStore.useFilters()

  const handleClick = (
    listMode: 'all' | 'proposals' | 'orders' | 'futureDelivery'
  ) => {
    const defaultSort =
      listMode === 'proposals'
        ? [{ field: 'proposalId', sort: 'desc' as const }]
        : [{ field: 'orderId', sort: 'desc' as const }]
    setSort(defaultSort)
    setFilters({ ...filters, listMode: listMode })
    setPagination({ page: 0 })
  }

  const { open, close, isOpen } = useDisclosure()

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignContent: 'flex-end'
      }}
    >
      <ButtonGroup
        size="small"
        sx={{ display: { md: 'flex', sm: 'none', xs: 'none' } }}
        style={{ flexWrap: 'wrap' }}
      >
        <MuiButton
          variant={
            filters?.listMode === 'proposals' || !filters
              ? 'contained'
              : 'outlined'
          }
          onClick={() => handleClick('proposals')}
          name="listMode"
          style={{ width: '150px' }}
        >
          Orçamentos
        </MuiButton>
        <MuiButton
          variant={
            filters?.listMode === 'orders' || !filters
              ? 'contained'
              : 'outlined'
          }
          onClick={() => handleClick('orders')}
          name="listMode"
          style={{ width: '150px' }}
        >
          Pedidos
        </MuiButton>
        <MuiButton
          variant={
            filters?.listMode === 'futureDelivery' || !filters
              ? 'contained'
              : 'outlined'
          }
          onClick={() => handleClick('futureDelivery')}
          name="listMode"
          style={{ width: '150px' }}
        >
          Entrega Futura
        </MuiButton>
      </ButtonGroup>
      <ButtonGroup size="small" sx={{ display: { md: 'none' } }}>
        <MuiButton
          variant={
            filters?.listMode === 'proposals' || !filters
              ? 'contained'
              : 'outlined'
          }
          onClick={() => handleClick('proposals')}
          name="listMode"
        >
          Orçamentos
        </MuiButton>
        <MuiButton
          variant={
            filters?.listMode === 'orders' || !filters
              ? 'contained'
              : 'outlined'
          }
          onClick={() => handleClick('orders')}
          name="listMode"
        >
          Pedidos
        </MuiButton>
        <MuiButton
          variant={
            filters?.listMode === 'futureDelivery' || !filters
              ? 'contained'
              : 'outlined'
          }
          onClick={() => handleClick('futureDelivery')}
          name="listMode"
        >
          Entrega Futura
        </MuiButton>
        <MuiButton variant={'outlined'} onClick={open} name="listMode">
          Contratos
        </MuiButton>
      </ButtonGroup>
      <SelectUnityModal isOpen={isOpen} close={close} />
    </div>
  )
}
